import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { Badge, type BadgeCustomIcon } from "@jti/core-components/components/Badge";

export type LeftBadgeProps = {
  isFreeTrialProduct?: boolean;
  label?: string;
  customIcon?: BadgeCustomIcon;
};

export const LeftBadge: FC<LeftBadgeProps> = ({ isFreeTrialProduct, label, customIcon }) => {
  const { __ } = useTranslations();
  if (isFreeTrialProduct) {
    return <Badge variant="ghost" label={__("product.badge.freeTrial")} />;
  }
  if (label) {
    return <Badge variant="ghost" label={label} customIcon={customIcon} />;
  }
  return <span />;
};
